import React, { PureComponent } from "react"
import { connect } from "react-redux"

import { isTequilaSelector } from "../../services/options/selectors"
import ModalBody from "../ModalBody/ModalBody"
import SubscriptionModal from "../../../../app/scripts/modules/Auth/SubscriptionModal"
import DebugModal from "../../../../app/scripts/modules/Debug/DebugModal"
import { hideModal as _hideModal } from "../../services/modals/actions"
import { removeBanner as _removeBanner } from "../../services/remoteConfig/actions"
import InfoModal from "../InfoModal/InfoModal"
import Translate from "../../../../app/scripts/components/Translate"
import AlertModal from "../AlertModal/AlertModal"
import { bannersConfigSelector } from "../../services/remoteConfig"
import type { BannersConfig } from "../../services/remoteConfig"
import { windowTypeSelector } from "../../services/window"
import { handleBlockScrollBody } from "../../utils/scrollUtils"
import type { ModalsState } from "../../services/modals/reducer"
import type { ModalType } from "../../services/modals/actions"
import maybeTranslate from "../../../../app/scripts/tools/maybeTranslate"
import {
  handleClosedBannerCookies,
  shouldShowAlert,
} from "../../services/remoteConfig/bannerHelper"
import type { WindowType } from "../../consts/windowConsts"

type Props = {
  // @ts-expect-error: Flow to TS migration.
  modals: ModalsState
  banner: {
    text: string[]
    showOnMobile: boolean
  }
  isTequila: boolean
  close: (arg1: string) => void
  hideModal: (arg1: string) => void
  removeBanner: (arg1: number) => void
  windowType: WindowType
  bannersConfig: BannersConfig
}

class Modals extends PureComponent<Props> {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  closeSingleAlert = (bannersConfig: any, index: number) => {
    const { hideModal, removeBanner } = this.props

    if (bannersConfig.banners.length === 1) {
      hideModal("exponea")
    }

    removeBanner(index)
  }

  // @ts-expect-error: Flow to TS migration.
  handleCloseKeyDown = (ev: KeyboardEvent, modal: ModalsState) => {
    const { close } = this.props

    if (ev.keyCode === 13) {
      close(modal)
    } else if (ev.keyCode === 32) {
      ev.preventDefault() // to prevent default scrolling down the modal
      close(modal)
    }
  }

  render() {
    const { close, modals, bannersConfig, windowType } = this.props

    if (modals.get("errorModal")) {
      const params = modals.get("errorModal").toObject()
      return (
        <ModalBody
          onClose={() => close("errorModal")}
          // @ts-expect-error: Flow to TS migration.
          onKeyDown={(ev) => this.handleCloseKeyDown(ev, "errorModal")}
        >
          <InfoModal onClose={() => close("errorModal")}>
            {params.translate ? <Translate tKey={params.error} /> : <span>{params.error}</span>}
          </InfoModal>
        </ModalBody>
      )
    }
    if (modals.get("subscription")) {
      return (
        <ModalBody
          onClose={() => close("subscription")}
          // @ts-expect-error: Flow to TS migration.
          onKeyDown={(ev) => this.handleCloseKeyDown(ev, "subscription")}
          passedClasses="SubscriptionModal"
          closeOnOverlayClick
        >
          <SubscriptionModal
            {...modals.get("subscription").toObject()}
            onClose={() => close("subscription")}
          />
        </ModalBody>
      )
    }
    if (modals.get("debug")) {
      return (
        <ModalBody
          onClose={() => close("debug")}
          // @ts-expect-error: Flow to TS migration.
          onKeyDown={(ev) => this.handleCloseKeyDown(ev, "debug")}
          wide
          props
        >
          <DebugModal {...modals.get("debug").toObject()} onClose={() => close("debug")} />
        </ModalBody>
      )
    }
    if (modals.get("exponea")) {
      const showAlerts = shouldShowAlert(windowType, bannersConfig)
      const translatedBannerText = bannersConfig.banners.map(maybeTranslate)

      return (
        <div className="Modals-RemoteConfigWrapper">
          {modals.get("exponea") && showAlerts && (
            <AlertModal
              bannerText={translatedBannerText}
              onClose={(index) => this.closeSingleAlert(bannersConfig, index)}
            />
          )}
        </div>
      )
    }

    return <div className="no-modal" />
  }
}

const ConnectedModals = connect(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: any) => ({
    modals: state.modals,
    bannersConfig: bannersConfigSelector(state),
    windowType: windowTypeSelector(state),
    isTequila: isTequilaSelector(state),
  }),
  (dispatch) => ({
    close: (modalName: ModalType) => {
      handleBlockScrollBody(false)
      dispatch(_hideModal(modalName))
    },
    hideModal: (modalName: ModalType) => {
      dispatch(_hideModal(modalName))
    },
    removeBanner: (index: number) => {
      handleClosedBannerCookies(index)
      dispatch(_removeBanner(index))
    },
  }),
  // @ts-expect-error: React upgrade
)(Modals)

export default ConnectedModals
